// Gun finishes (Service Record rewards): the six kit colours every placeholder gun is built from,
// swapped per finish. guns.ts builds and caches one geometry per weapon + finish, so a finish costs
// nothing per frame. Ids and names live in sim/progression.ts (FINISHES).

import { PAL } from '../render/palette';
import { Finish } from '../../sim/progression';

export interface FinishPalette { metal: number; steel: number; brass: number; wood: number; grip: number; cream: number }

const BASE: FinishPalette = { metal: PAL.gunmetal, steel: PAL.steel, brass: PAL.brass, wood: PAL.wood, grip: PAL.scarfBrown, cream: PAL.gearCream };

const PALETTES: Record<number, FinishPalette> = {
  [Finish.Blued]: BASE,
  [Finish.Nickel]: { ...BASE, metal: 0xc6ccd1, steel: 0xf2f4f4, brass: 0xd6d3c9, cream: 0xdde2e6 },
  // straw-and-blue forge mottle, read at gun size as a warm frame on a blue barrel
  [Finish.CaseHardened]: { ...BASE, metal: 0x8a683a, steel: 0x3d5878, grip: 0x4a2f20, wood: 0x6e4a2c, cream: 0xcdb790 },
  [Finish.Engraved]: { ...BASE, metal: 0xb08a4a, steel: 0xd7b56f, brass: 0xe8c77f, grip: 0x3a2a20, wood: 0x5a3b24, cream: 0xe6d1a0 },
  [Finish.BoneGrip]: { ...BASE, metal: 0x232a38, steel: 0x434e5e, grip: 0xf4ebd5, wood: 0xeadfc4 },
  [Finish.Blackout]: { metal: 0x1d1d1f, steel: 0x2c2c30, brass: 0x38363a, wood: 0x242222, grip: 0x1f1c1c, cream: 0x3c3b3d },
  [Finish.Gold]: { metal: 0xd29a2e, steel: 0xf0cd6a, brass: 0xffd978, wood: 0x6b3b22, grip: 0x5a2f1d, cream: 0xf6e4a6 },
};

export function finishPalette(f: number): FinishPalette {
  return PALETTES[f] ?? BASE;
}

/** CSS swatches for the record screen: frame, barrel, trim, grip. */
export function finishSwatch(f: number): string[] {
  const p = finishPalette(f);
  return [p.metal, p.steel, p.brass, p.grip].map((c) => '#' + c.toString(16).padStart(6, '0'));
}
